module.exports = __webpack_public_path__ + "img/thumbnail_CapuchinMonkey_f_normal.249d9b57.png";